import { createElement, useState } from 'react';
import './index.scss';
import arrLeft from '../../assets/icon/position/img.png';
import location from '../../assets/icon/position/location.png';
import { default as SearchBar } from '../search-bar/search-bar';
import { groupCitiesByInitial } from "../../utils/textUtil";
const ContentList = function NavigationList({ open, itemArray, setIsOpen, setCurrent, currentLocation }) {
    let indexKeys = [];
    const handleItem = (itemArrays, searchValue) => {
        if (!itemArrays) {
            return {};
        }
        const groupName = groupCitiesByInitial(itemArrays);
        indexKeys = Object.keys(groupName);
        if (searchValue) {
            indexKeys.forEach(item => {
                const cityArray = groupName[item];
                const filterCity = cityArray.filter(locationItem => locationItem.address.indexOf(searchValue) != -1);
                if (!filterCity || filterCity.length == 0) {
                    delete groupName[item];
                }
                else {
                    groupName[item] = filterCity;
                }
            });
        }
        return groupName;
    };
    const [cityList, setCityList] = useState(handleItem(itemArray));
    console.log('cityList', cityList);
    const changeHandle = (position) => {
        console.log('changeHandle', position);
        setCurrent(position);
        setIsOpen();
    };
    const indexClickHandle = (index) => {
        const indexStr = 'index-' + index;
        const dom = document.getElementById(indexStr);
        if (dom) {
            dom.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    };
    const handleSearch = (name) => {
        const data = handleItem(itemArray, name);
        setCityList(data);
    };
    const hotCityArray = itemArray ? itemArray.filter(item => item.isHot) : [];
    return (createElement("div", { className: "location-list", style: { display: open ? 'block' : 'none' } },
        createElement("div", { className: "location-list-head" },
            createElement("img", { src: arrLeft, className: "location-list-head-img", onClick: setIsOpen }),
            createElement(SearchBar, { onConfirm: (value) => handleSearch(value) })),
        createElement("div", { className: "location-city-box location-list-location" },
            createElement("img", { src: location, className: "location-list-location-img" }),
            createElement("span", { className: "location-list-location-text", onClick: setIsOpen }, currentLocation.address)),
        hotCityArray && hotCityArray.length ? (createElement("div", { className: "location-list-hot" },
            createElement("div", { className: "location-list-hot-title" }, "\u70ED\u95E8\u57CE\u5E02"),
            createElement("div", { className: "location-list-hot-content" }, hotCityArray ? hotCityArray.map(item => createElement("div", { className: "location-city-box location-list-hot-content-item", onClick: () => changeHandle(item) }, item.address)) : ''))) : '',
        createElement("div", { className: "location-list-city" }, cityList ? Object.keys(cityList).map(item => (createElement("div", { className: "location-list-city-box" },
            createElement("div", { className: "location-list-city-box-type", id: `index-${item}` }, item),
            cityList[item].map(cityInfo => (createElement("div", { className: "location-list-city-box-name", onClick: () => changeHandle(cityInfo) }, cityInfo.address)))))) : ''),
        createElement("div", { className: "location-list-index-bar" }, cityList ? Object.keys(cityList).map(item => (createElement("div", { className: "location-list-index-bar-name", onClick: () => indexClickHandle(item) }, item))) : '')));
};
export default ContentList;
